import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-unloaded',
  template: `<router-outlet></router-outlet>`,
  styles: [
    `
      :host {
        display: flex;
        flex-grow: 1;
        overflow: auto;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnloadedComponent {
  constructor() {}
}
